// extracted by mini-css-extract-plugin
module.exports = {"link":"link-2k47L"};